var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReward = function SvgReward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.71 13.51H10.29v8.237h11.42zm-11.42-1.254c-.713 0-1.29.562-1.29 1.254v8.237C9 22.439 9.577 23 10.29 23h11.42c.713 0 1.29-.561 1.29-1.253V13.51c0-.692-.577-1.254-1.29-1.254z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.632 22.284v-9.311h1.29v9.31z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.975 9.475a1.025 1.025 0 0 0-.185 1.465c.136.17.313.285.506.348l.02.006 1.641.645-.266-1.843-.002-.008c-.032-.153-.1-.3-.206-.433a1.095 1.095 0 0 0-1.508-.18m-1.201 2.237c-.804-1-.621-2.444.407-3.225s2.514-.604 3.318.396a2.26 2.26 0 0 1 .462.993l.35 2.426c.105.717-.629 1.274-1.32 1.002l-2.122-.834a2.36 2.36 0 0 1-1.095-.758",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.033 9.495c.461.363.532 1.02.159 1.469-.139.166-.318.28-.512.339l-.02.005-1.653.617.3-1.838.002-.008c.034-.152.105-.299.214-.43a1.095 1.095 0 0 1 1.51-.154m1.161 2.257a2.254 2.254 0 0 0-.35-3.23c-1.014-.8-2.502-.647-3.323.339a2.3 2.3 0 0 0-.48.985l-.395 2.42c-.116.714.607 1.283 1.302 1.024l2.138-.798c.421-.132.81-.381 1.108-.74",
    clipRule: "evenodd"
  })));
};
export default SvgReward;